<!-- ============================================================== -->
<!-- row -->
<!-- ============================================================== -->
<div class="row">
  <!-- Card column -->
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h4 class="mb-32">Basic Tab</h4>
        <mat-tab-group mat-stretch-tabs="false">
          <mat-tab label="Tab 1">
            <mat-card-content>Content 1</mat-card-content>
          </mat-tab>
          <mat-tab label="Tab 2">
            <mat-card-content>Content 2</mat-card-content>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- ============================================================== -->
<!-- row -->
<!-- ============================================================== -->
<div class="row">
  <!-- Card column -->
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h4 class="mb-32">Complex Tab Example (Responsive tab)</h4>
        <mat-tab-group mat-stretch-tabs="false" class="demo-tab-group">
          <mat-tab label="Tab 1">
            <div class="demo-tab-content">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue.
              Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus.
              In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec,
              feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor,
              orci enim rutrum enim, vel tempor sapien arcu a tellus.
            </div>
          </mat-tab>
          <mat-tab label="Tab 2">
            <ng-template mat-tab-label>
              ⭐
            </ng-template>
            <div class="demo-tab-content">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue.
              Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus.
              In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec,
              feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor,
              orci enim rutrum enim, vel tempor sapien arcu a tellus.
            </div>
          </mat-tab>
          <mat-tab label="Tab 3" disabled>
            No content
          </mat-tab>
          <mat-tab label="Tab 4">
            <div class="demo-tab-content">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue.
              Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus.
              In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec,
              feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor,
              orci enim rutrum enim, vel tempor sapien arcu a tellus.
              <br />
              <br />
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue.
              Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus.
              In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec,
              feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor,
              orci enim rutrum enim, vel tempor sapien arcu a tellus.
            </div>
          </mat-tab>
          <mat-tab label="Tab 5">
            No content
          </mat-tab>
          <mat-tab label="Tab 6">
            No content
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- ============================================================== -->
<!-- row -->
<!-- ============================================================== -->
<div class="row">
  <!-- Card column -->
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h4 class="mb-32">Label alignment</h4>

        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="First">
            <div class="p-20">Content 1</div>
          </mat-tab>
          <mat-tab label="Second">
            <div class="p-20">Content 2</div>
          </mat-tab>
          <mat-tab label="Third">
            <div class="p-20">Content 3</div>
          </mat-tab>
        </mat-tab-group>

        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
          <mat-tab label="First">
            <div class="p-20">Content 1</div>
          </mat-tab>
          <mat-tab label="Second">
            <div class="p-20">Content 2</div>
          </mat-tab>
          <mat-tab label="Third">
            <div class="p-20">Content 3</div>
          </mat-tab>
        </mat-tab-group>

        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="end">
          <mat-tab label="First">
            <div class="p-20">Content 1</div>
          </mat-tab>
          <mat-tab label="Second">
            <div class="p-20">Content 2</div>
          </mat-tab>
          <mat-tab label="Third">
            <div class="p-20">Content 3</div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- ============================================================== -->
<!-- row -->
<!-- ============================================================== -->
<div class="row">
  <!-- Card column -->
  <div class="col-12">
    <mat-card>
      <mat-card-content class="mb-0">
        <h4 class="mb-32">Tab group animations</h4>

        <div class="ps-20 pe-20 pb-20">
          <p class="fw-medium m-0 fs-16">No animation</p>
          <mat-tab-group mat-stretch-tabs="false" class="mb-32" animationDuration="0ms">
            <mat-tab label="First">Content 1</mat-tab>
            <mat-tab label="Second">Content 2</mat-tab>
            <mat-tab label="Third">Content 3</mat-tab>
          </mat-tab-group>

          <p class="fw-medium m-0 fs-16">Very slow animation</p>
          <mat-tab-group mat-stretch-tabs="false" animationDuration="2000ms">
            <mat-tab label="First">Content 1</mat-tab>
            <mat-tab label="Second">Content 2</mat-tab>
            <mat-tab label="Third">Content 3</mat-tab>
          </mat-tab-group>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
